import React from 'react';

import Descriptions from '../styled/Descriptions';
import Host from '../styled/Host';
import Paragraph1 from '../styled/Paragraph1';
import Wrapper from '../styled/Wrapper';
import Button from './styled/Button';

interface UnsupportedProps {
  setAccept: (accept: boolean) => void;
}

const Unsupported = ({ setAccept }: UnsupportedProps) => {
  const onContinue = () => {
    setAccept(true);
  };

  return (
    <Host>
      <Wrapper>
        <Descriptions>
          <Paragraph1>UNSUPPORTED BROWSER</Paragraph1>
        </Descriptions>

        <Button onClick={onContinue}> Continue</Button>
      </Wrapper>
    </Host>
  );
};

export default Unsupported;
